import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import SEO from '../components/SEO/SEO';
import WhaleTradesPanel from '../components/StatsPage/WhaleTradesPanel';
import LiquidationsPanel from '../components/StatsPage/LiquidationsPanel';
import EtfFlowPanel from '../components/StatsPage/EtfFlowPanel';
import BtcPricePanel from '../components/StatsPage/BtcPricePanel';
import AiCommentaryPanel from '../components/StatsPage/AiCommentaryPanel';
import ExchangeVolumePanel from '../components/StatsPage/ExchangeVolumePanel';
import TraderMapSignalPanel from '../components/StatsPage/TraderMapSignalPanel';
import TradesPerMinPanel from '../components/StatsPage/TradesPerMinPanel';
import TradesPerSecPanel from '../components/StatsPage/TradesPerSecPanel';
import { useStatsData } from '../hooks/useStatsData';
import { useLivePrices } from '../hooks/useLivePrices';
import './StatsPage.css';


function StatsPage() {
  const { t } = useTranslation();
  const { data, loading, error, hours, setHours } = useStatsData(24);
  const livePrices = useLivePrices();

  const timeTabs = [
    { label: '1H', value: 1 },
    { label: '4H', value: 4 },
    { label: '24H', value: 24 },
  ];

  if (loading && !data) {
    return (
      <div className="stats-page">
        <Header />
        <div className="stats-loading">{t('stats.loading')}</div>
      </div>
    );
  }

  if (error && !data) {
    return (
      <div className="stats-page">
        <Header />
        <div className="stats-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="stats-page">
      <SEO
        title={t('stats.seoTitle')}
        description={t('stats.seoDescription')}
      />
      <Header />
      <div className="stats-content">
        <div className="stats-time-tabs">
          {timeTabs.map((tab) => (
            <button
              key={tab.value}
              className={`stats-time-tab ${hours === tab.value ? 'active' : ''}`}
              onClick={() => setHours(tab.value)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="stats-grid">
          <WhaleTradesPanel
            whaleSummary={data?.whaleSummary}
            coinStats={data?.coinStats}
            hours={hours}
          />
          <LiquidationsPanel
            liquidationSummary={data?.liquidationSummary}
            coinStats={data?.liqCoinStats}
            hours={hours}
          />
          <EtfFlowPanel etfFlows={data?.etfFlows} />
          <BtcPricePanel
            livePrice={livePrices.getPrice('BTC')}
            formatPrice={livePrices.formatPrice}
            btcPriceData={data?.btcPrice}
          />
          <AiCommentaryPanel aiCommentary={data?.aiCommentary} />
          <ExchangeVolumePanel exchangeVolumes={data?.exchangeVolumes} hours={hours} />
          <TraderMapSignalPanel signal={data?.signal} />
          <TradesPerMinPanel tradeRates={data?.tradeRates} />
          <TradesPerSecPanel />
        </div>
      </div>
    </div>
  );
}

export default StatsPage;
